import { createContext, useContext } from "react"

type SearchOverlayContext = {
  showOverlay: boolean
  setShowOverlay: (open: boolean) => void
}

export const SearchOverlayContext = createContext<SearchOverlayContext>({
  showOverlay: false,
  setShowOverlay: () => undefined,
})

export const useSearchOverlay = () => useContext(SearchOverlayContext)
